import React from 'react'
import * as yup from 'yup'
import { BaseForm, FormGroup } from '@softwaredev_cegeka/stix-form'
import { SelectPicker } from '@softwaredev_cegeka/stix-form-select'
import CompanySelect from 'src/components/CompanySelect'

class DefaultGroupForm extends BaseForm {
    pages = [
        {
            title: 'Default Groups',
            renderMethod: this.renderDefaultGroupsTab,
            validationSchema: yup.object().shape({
                group_names: yup
                    .array()
                    .ensure()
                    .of(
                        yup.object().shape({
                            label: yup.string(),
                            value: yup.string(),
                        })
                    )
                    .min(1, 'Please select at least one group'),
            }),
        },
    ]
    initialValues = {
        group_names: [],
    }

    async generatePayload(values) {
        return {
            company_id: values.company.value,
            group_names: values.group_names.map(val => val.value),
        }
    }

    async submitData(payload) {
        return await this.props.apiClient.createDefaultGroups(payload)
    }

    mapDefaultGroupToOption(defaultGroup) {
        return {
            label: defaultGroup.name,
            value: defaultGroup.name,
        }
    }

    renderDefaultGroupsTab() {
        const options = this.props.defaultGroups.map(
            this.mapDefaultGroupToOption
        )
        return (
            <>
                <FormGroup>
                    <CompanySelect
                        {...this.getCommonSelectProps('company')}
                        required
                        label="Company"
                    />
                </FormGroup>
                <FormGroup>
                    <SelectPicker
                        options={options}
                        label="Groups to create"
                        {...this.getCommonSelectProps('group_names')}
                    />
                </FormGroup>
            </>
        )
    }
}

export default DefaultGroupForm
